import { fetchWorkflowEnrollments } from './workflowInsightsApi';
import { EMPTY_TRIGGER_STATS } from './workflowTriggerUtils';

function mapEnrollmentRow(row) {
  const name = row.contact_name
    || row.name
    || [row.first_name, row.last_name].filter(Boolean).join(' ')
    || 'Unknown contact';
  return {
    id: row.id || row.execution_id,
    contactName: name,
    email: row.email || row.contact_email || '—',
    dateTime: row.date_enrolled || row.created_at,
    matchStatus: 'matched',
    reasonForUnmatch: '—',
  };
}

/**
 * Loads trigger enrollment stats from workflow enrollments when available.
 * Returns empty stats when the workflow is new or the API is unavailable.
 */
export async function fetchTriggerEnrollmentStats({
  token,
  workflowId,
  agencyId,
  triggerId,
  startDate,
  endDate,
  contactId,
  page = 1,
  pageSize = 10,
}) {
  if (!token || !workflowId || workflowId === 'new') {
    return { ...EMPTY_TRIGGER_STATS, page, pageSize };
  }

  try {
    const data = await fetchWorkflowEnrollments({
      token,
      workflowId,
      agencyId,
      params: {
        page,
        page_size: pageSize,
        start_date: startDate || undefined,
        end_date: endDate || undefined,
        contact_id: contactId || undefined,
      },
    });

    const items = data.items || [];
    const total = data.total ?? items.length;
    const matched = items.length;
    const attempted = total;
    const unmatched = Math.max(attempted - matched, 0);
    const matchedRate = attempted > 0 ? (matched / attempted) * 100 : 0;

    return {
      attempted,
      matched,
      unmatched,
      matchedRate,
      rows: items.map(mapEnrollmentRow),
      total,
      page: data.page || page,
      pageSize: data.page_size || pageSize,
      triggerId,
    };
  } catch {
    return { ...EMPTY_TRIGGER_STATS, page, pageSize, triggerId };
  }
}

export async function fetchTriggerUnmatchReasons() {
  return [];
}
